export const MessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
  TOOL: 'tool',
} as const;

export type MessageRoleType = (typeof MessageRole)[keyof typeof MessageRole];

export const CHAT_COMPLETION_OBJECT = 'chat.completion';
export const LOCAL_CONVERSATION_LIMIT = 50;
/** Matches backstage-agent-backend `MAX_HISTORY_TURNS` in router.ts */
export const BACKSTAGE_AGENT_MAX_HISTORY_TURNS = 20;
export const LOCAL_RAG_SOURCE = 'all';
export const TEMP_CONVERSATION_PREFIX = 'temp';
export const POPOUT_COMMAND_EVENT = 'mga-popout-command';

export const PopoutCommand = {
  OPEN: 'open',
  CLOSE: 'close',
  MINIMIZE: 'minimize',
  EXPAND: 'expand',
} as const;

export type PopoutCommandType =
  (typeof PopoutCommand)[keyof typeof PopoutCommand];

export const STORAGE_KEYS = {
  CONVERSATION_MAPPINGS: 'mga-conversation-mappings',
  POPOUT_STATE: 'mga-popout-state',
  localConversation: (conversationId: string) =>
    `mga-conversation-${conversationId}`,
  tokenUsage: (conversationId: string) => `mga-tokens-${conversationId}`,
  ragConversation: (conversationId: string) =>
    `mga-rag-conversation-${conversationId}`,
  RAG_CONVERSATION_LIST: 'mga-rag-conversation-list',
  ragEmbeddings: (conversationId: string) =>
    `mga-rag-embeddings-${conversationId}`,
  agentConversation: (conversationId: string) =>
    `mga-agent-conversation-${conversationId}`,
  AGENT_CONVERSATION_LIST: 'mga-agent-conversation-list',
} as const;

export const BackstageAgentStreamEventType = {
  ROUTING: 'routing',
  SUB_AGENT_START: 'sub_agent_start',
  SUB_AGENT_COMPLETE: 'sub_agent_complete',
  SYNTHESIZING: 'synthesizing',
  COMPLETE: 'complete',
  ERROR: 'error',
  CANCELLED: 'cancelled',
} as const;

export const BackstageAgentStatus = {
  COMPLETED: 'completed',
  MAX_STEPS: 'max_steps',
  TIMEOUT: 'timeout',
  ERROR: 'error',
  CANCELLED: 'cancelled',
} as const;

export const AGENT_PROGRESS_MESSAGE_ID_SUFFIX = '-assistant-progress';

export const isAgentProgressMessageId = (messageId?: string): boolean =>
  messageId?.includes(AGENT_PROGRESS_MESSAGE_ID_SUFFIX) ?? false;
